import React from "react";
import SocialIcon from "../../shared/SocialIcon";
import MenuCard, { MenuCardProps } from "../../shared/MenuCard";

interface MenuTabProps {}

const MenuTab: React.FC<MenuTabProps> = (props) => {
  const cardData: Array<MenuCardProps> = [
    {
      imgSrc: "/images/recipe1.png",
      imgAlt: "icon",
      imgLightBox: ["/images/recipe1.png", "/images/imagslide.png"],
      descDetails: [
        { title: "Production date", text: "14:00, 29.01.2024" },
        { title: "Delivering restaurant", text: "description" },
      ],
    },
    {
      imgSrc: "/images/recipe2.png",
      imgAlt: "icon",
      descDetails: [{ title: "Producing chef cook", text: "Max Muster" }],
    },
    {
      imgSrc: "/images/recipe3.png",
      imgAlt: "icon",
      descDetails: [
        { title: "Issuer of recipe", text: "Andreas Caminada" },
        {
          title: "Website",
          text: "",
          children: (
            <div className="menu-card-desc-socials">
              <SocialIcon
                href=""
                imgSrc="/images/instagram.svg"
                imgAlt="instagram icon"
              />
              <SocialIcon
                href=""
                imgSrc="/images/Vector1.svg"
                imgAlt="Linkedin icon"
              />
              <SocialIcon
                href=""
                imgSrc="/images/facebook.svg"
                imgAlt="facebook icon"
              />
            </div>
          ),
        },
      ],
    },
  ];
  return (
    <div className="tab-pane fade show active" id="menu-tab-content">
      <div className="menu-card-wrap">
        {cardData.map((data, index) => (
          <MenuCard
            key={index}
            imgSrc={data.imgSrc}
            imgAlt={data.imgAlt}
            imgLightBox={data?.imgLightBox}
            descDetails={data.descDetails}
          />
        ))}
      </div>
    </div>
  );
};

export default MenuTab;
